export let nociceTableLabels = [
//   {
//     label: '序号',
//     value: 'sequenceNumber'
//   },
  {
    label: '消息标题',
    value: 'title'
  },
  //   {
  //     label: '发送方式',
  //     value: ''
  //   },
  {
    label: '发送对象',
    value: 'send_to'
  }
]
// 消息发布对象radio
export let sendToRadio = [
  {
    label: '全部用户',
    value: 'all'
  },
  {
    label: '指定用户',
    value: 'select'
  }
]
